var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHome = function SvgHome(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 19.2416V11.524C18.5 11.1958 18.339 10.8885 18.0692 10.7018L12.5692 6.89407C12.2268 6.65699 11.7732 6.65699 11.4308 6.89407L5.93079 10.7018C5.66099 10.8885 5.5 11.1958 5.5 11.524V19.2416C5.5 19.7939 5.94772 20.2416 6.5 20.2416H17.5C18.0523 20.2416 18.5 19.7939 18.5 19.2416Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3902 4.12534C12.5488 3.56237 11.451 3.56239 10.6096 4.12538L8.00009 5.87154V4.99991C8.00009 4.44762 7.55237 3.99991 7.00009 3.99991C6.4478 3.99991 6.00009 4.44762 6.00009 4.99991V7.20984L3.16597 9.1063C2.47746 9.56701 2.2928 10.4986 2.75351 11.1871C3.21422 11.8756 4.14585 12.0603 4.83435 11.5996L7.28769 9.95793C7.4815 9.89983 7.65057 9.78453 7.77532 9.63164L11.9999 6.80473L19.166 11.5996C19.8545 12.0603 20.7861 11.8756 21.2468 11.1871C21.7075 10.4986 21.5228 9.56696 20.8343 9.10627L13.3902 4.12534Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "home.4bc09846d93fe9c13994f1a56681fd23.svg";